<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{title}}<button type="button" class="close"
                           @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row justify-content-center orange center mb-2"><h6>Message Type</h6></div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4"
                          label="Notification"
                          :state="stateForField('notificationId')"
                          :invalid-feedback="errorForField('notificationId')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="notificationName" :variant="hasError('notificationId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="notification in notifications" :key="notification.organizationCustomNotificationId"
                                 @click.prevent="setNotification(notification)">{{ notification.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4"
                          label="Preview"
                          label-class="text-right">
              <b-textarea v-model="notificationPreview" readonly></b-textarea>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div class="w-100"><hr/></div>
    <div class="row justify-content-center orange center mb-2"><h6>Message Filters</h6></div>
    <div class="row align-items-center mb-3">
      <div class="col-1 column"/>
      <div class="col-4 text-right column">Date Range:</div>
      <div class="col-6 text-left column">{{ formatDate(fromDate) }} - {{ formatDate(toDate) }}</div>
    </div>
    <div class="row align-items-center mb-3">
      <div class="col-1 column"/>
      <div class="col-4 text-right column">Provider:</div>
      <div class="col-4 text-left column"><span v-html="providerNames()"></span></div>
    </div>
    <div class="row align-items-center mb-3">
      <div class="col-1 column"/>
      <div class="col-4 text-right column">Location:</div>
      <div class="col-4 text-left column"><span v-html="locationNames()"></span></div>
    </div>
    <div class="row align-items-center mb-3">
      <div class="col-1 column"/>
      <div class="col-4 text-right column">Total Appointments:</div>
      <div class="col-4 text-left column">{{ patientCount }}</div>
    </div>
    <div class="row align-items-center mb-3">
      <div class="col-1 column"/>
      <div class="col-4 text-right column">Statuses:</div>
      <div class="col-4 text-left column"><span v-html="statusNames()"></span></div>

    </div>
    <div class="row align-items-center mb-3">
      <div class="col-1 column"/>
      <div class="col-4 text-right column">Intake Flows:</div>
      <div class="col-4 text-left column"><span v-html="intakeNames()"></span></div>
    </div>

    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="confirmNotifications()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Send</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>

  </b-modal>

</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import moment from 'moment-timezone'

  export default {
    name: 'SendMassCustomNotification',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      fromDate: {
        type: Date,
        required: true
      },

      toDate: {
        type: Date,
        required: true
      },

      providerIds: {
        type: Array,
        required: true
      },

      locationIds: {
        type: Array,
        required: true
      },

      visitStatuses: {
        type: Array,
        required: true
      },

      intakeFlows: {
        type: Array,
        required: true
      },

      title: {
        type: String,
        default: 'Send Message to All'
      }
    },

    data () {
      return {
        notifications: [],
        notificationId: 0,
        isSaving: false,
        notificationName: 'Click to select',
        notificationPreview: '',
        patientCount: 0
      }
    },

    computed: {
      providers () {
        return this.$store.organization.providers
      },

      locations () {
        return this.$store.organization.locations
      },

      visitTypes () {
        return this.$store.organization.visitTypes
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      }
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.loadData()
      },

      validate () {
        this.clearAllErrors()

        if (!this.notificationId > 0) {
          this.addErrorForField('notificationId', 'You must select a notification')
        }

        return !this.hasErrors()
      },

      setNotification (notification) {
        this.notificationId = notification.organizationCustomNotificationId
        this.notificationName = notification.name
        this.notificationPreview = notification.preview
      },

      loadData () {

        api.get('/Dashboard/Visit/CustomNotifications').then(response => {
          // filter out payment templates
          this.notifications = []
          for (let i = 0; i < response.data.length; i++) {
            const current = response.data[i]
            if (current.notificationType === 17 || current.notificationType === 18) {
              continue
            }
            this.notifications.push(current)
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load notifications: ' + error.message, error)
          }
        })

        const parameters = {
          searchTerm: null,
          fromDate: this.fromDate,
          toDate: this.toDate,
          providerIds: this.providerIds,
          locationIds: this.locationIds,
          visitStates: this.visitStatuses,
          visitTypes: this.intakeFlows,
          pageSize: 1,
          page: 1
        }

        this.errors = []
        api.post('/Dashboard/Visits', parameters).then(response => {
          this.patientCount = response.data.totalVisits
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load appointments: ' + error.message, error)
            this.errors = ['Error loading appointments: ' + error.message]
          }
        })

      },

      confirmNotifications () {
        if (!this.validate()) {
          return
        }

        const notificationSettings = {
          dateRange: this.formatDate(this.fromDate) + ' - ' + this.formatDate(this.toDate),
          locationNames: this.locationNames(),
          providerNames: this.providerNames(),
          intakeNames: this.intakeNames(),
          patientCount: this.patientCount,
          message: this.notificationPreview,
          visitStatuses: this.visitStatuses
        }
        this.$emit('confirmMassNotifications', notificationSettings)
      },

      notificationsConfirmed () {
        this.save()
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        const parameters = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          providerIds: this.providerIds,
          locationIds: this.locationIds,
          visitStatuses: this.visitStatuses,
          notificationId: this.notificationId,
          visitTypes: this.intakeFlows
        }

        this.isSaving = true
        api.post('/Dashboard/SendMassCustomNotificationSms/', parameters, { timeout: 90000 }).then(response => {
          this.$emit('update:visible', false)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to send notification: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      formatDate (date) {
        return moment(date).format('MMM Do YYYY hh:mmA')
      },

      providerNames () {
        if (this.providerIds.length) {
          const providerNames = this.providers.filter((provider) => {
            return (this.providerIds.includes(provider.providerId))
          }).map((provider) => provider.displayName)

          return providerNames.join('<br>')
        }

        return 'All Providers'
      },
      statusNames () {
        if (this.visitStatuses.length === 6) {
          return 'All Statuses'
        }
        if (this.visitStatuses.length) {
          let names = ''
          this.visitStatuses.forEach((status) => {
            names += '<br/>' + this.statusName(status)
          })
          return names
        }
        return 'No Statuses Selected'
      },
      statusName (status) {
        switch (status) {
        case 1: return 'Scheduled'
        case 2: return 'In Progress'
        case 3: return 'Pre Checked'
        case 4: return 'Needs Review'
        case 5: return 'Checked In'
        case 6: return 'Done'
        }
      },
      intakeNames () {
        if (this.visitTypes === null || this.intakeFlows.length === this.visitTypes.length) {
          return 'All Intake Flows'
        }
        if (this.intakeFlows.length) {
          const intakeNames = this.visitTypes.filter((flow) => {
            return (this.intakeFlows.includes(flow.organizationVisitTypeId))
          }).map((intake) => intake.name)
          return intakeNames.join('<br/>')
        }
        return 'No Intake Flows Selected'
      },
      locationNames () {
        if (this.locationIds.length) {
          const locationNames = this.locations.filter((location) => {
            return (this.locationIds.includes(location.locationId))
          }).map((location) => location.name)

          return locationNames.join('<br/>')
        }

        return 'All Locations'
      }
    },

    created () {
      this.$on('notificationsConfirmed', this.notificationsConfirmed)
    }

  }
</script>

<style scoped>

</style>
